export class ApprovalItemEntity {
    value: string;
    text: string;
    workFlowAction: string;
    isDefault = false;
    commentNecessary = false;
    certification = false;
    attachmentNecessary = false;
    signatureNecessary = false;
    defaultComment: string;

    constructor(value?: string, text?: string, wfAction?: string) {
        this.value = value;
        this.text = text;
        this.workFlowAction = wfAction;
    }
}
